"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oAuthFactoryReducer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _redux = require("redux");

var _constants = require("./oauth/constants");

var _constants2 = require("./users/constants");

var _constants3 = require("./roles/constants");

var _constants4 = require("./clients/constants");

var _constants5 = require("./apis/constants");

var _constants6 = require("./scopes/constants");

var _constants7 = require("./permissions/constants");

var _constants8 = require("./tenants/constants");

var _constants9 = require("./openid-configuration/constants");

var _oauthReducer = require("./oauth/oauth-reducer");

var _usersReducer = require("./users/users-reducer");

var _rolesReducer = require("./roles/roles-reducer");

var _clientsReducer = require("./clients/clients-reducer");

var _apisReducer = require("./apis/apis-reducer");

var _scopesReducer = require("./scopes/scopes-reducer");

var _permissionsReducer = require("./permissions/permissions-reducer");

var _tenantsReducer = require("./tenants/tenants-reducer");

var _openidConfigurationReducer = require("./openid-configuration/openid-configuration-reducer");

var _combineReducers;

var oAuthFactoryReducer = (0, _redux.combineReducers)((_combineReducers = {}, (0, _defineProperty2.default)(_combineReducers, _constants.AUTH_STATE_KEY_NAME, _oauthReducer.oAuthReducer), (0, _defineProperty2.default)(_combineReducers, _constants2.USERS_STATE_KEY_NAME, _usersReducer.usersReducer), (0, _defineProperty2.default)(_combineReducers, _constants3.ROLES_STATE_KEY_NAME, _rolesReducer.rolesReducer), (0, _defineProperty2.default)(_combineReducers, _constants7.PERMISSIONS_STATE_KEY_NAME, _permissionsReducer.permissionsReducer), (0, _defineProperty2.default)(_combineReducers, _constants4.CLIENTS_STATE_KEY_NAME, _clientsReducer.clientsReducer), (0, _defineProperty2.default)(_combineReducers, _constants5.APIS_STATE_KEY_NAME, _apisReducer.apisReducer), (0, _defineProperty2.default)(_combineReducers, _constants6.SCOPES_STATE_KEY_NAME, _scopesReducer.scopesReducer), (0, _defineProperty2.default)(_combineReducers, _constants9.OPENID_CONFIGURATION_STATE_KEY_NAME, _openidConfigurationReducer.openidConfigurationReducer), (0, _defineProperty2.default)(_combineReducers, _constants8.TENANTS_STATE_KEY_NAME, _tenantsReducer.tenantsReducer), _combineReducers));
exports.oAuthFactoryReducer = oAuthFactoryReducer;
//# sourceMappingURL=oauth-factory-reducer.js.map